module.exports = __webpack_public_path__ + "static/media/icon-_iconos-genericos-borrar.29038b0d.svg";